import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enCommon from "./locales/en/common.json";
import enAuth from "./locales/en/auth.json";
import enAdminPortal from "./locales/en/adminPortal.json";
import enMenuBar from "./locales/en/menuBar.json";
import enErrors from "./locales/en/errors.json";
import enWarnings from "./locales/en/warnings.json";
import enConfigureStorage from "./locales/en/configureStorage.json";
import enUsers from "./locales/en/users.json";
import enRoles from "./locales/en/roles.json";
import enConnectors from "./locales/en/connectors.json";
import enConfigureHeaders from "./locales/en/configureHeaders.json";
import enFeatureFlags from "./locales/en/featureFlags.json";
import enDashboards from "./locales/en/dashboards.json";
import enSearch from "./locales/en/search.json";
import enGrid from "./locales/en/grid.json";
import enCXoneConnector from "./locales/en/cxoneConnector.json";
import enFive9Connector from "./locales/en/five9Connector.json";
import enAmazonConnectConnector from "./locales/en/amazonConnect.json";
import enTranscription from "./locales/en/transcription.json";
import frCACommon from "./locales/fr-CA/common.json";
import frCAAuth from "./locales/fr-CA/auth.json";
import frCAAdminPortal from "./locales/fr-CA/adminPortal.json";
import frCAMenuBar from "./locales/fr-CA/menuBar.json";
import frCAErrors from "./locales/fr-CA/errors.json";
import frCAWarnings from "./locales/fr-CA/warnings.json";
import frCAConfigureStorage from "./locales/fr-CA/configureStorage.json";
import frCAUsers from "./locales/fr-CA/users.json";
import frCARoles from "./locales/fr-CA/roles.json";
import frCAConnectors from "./locales/fr-CA/connectors.json";
import frCAConfiugreHeaders from "./locales/fr-CA/configureHeaders.json";
import frCAFeatureFlags from "./locales/fr-CA/featureFlags.json";
import frCADashboards from "./locales/fr-CA/dashboards.json";
import frCASearch from "./locales/fr-CA/search.json";
import frCAGrid from "./locales/fr-CA/grid.json";
import frCACXoneConnector from "./locales/fr-CA/cxoneConnector.json";
import frCAFive9Connector from "./locales/fr-CA/five9Connector.json";
import frCAAmazonConnectConnector from "./locales/fr-CA/amazonConnect.json";
import frCATranscription from "./locales/fr-CA/transcription.json";
import enSummary from "./locales/en/summary.json";
import frCASummary from "./locales/fr-CA/summary.json";
import enSummaryTemplate from "./locales/en/summaryTemplate.json";
import frCASummaryTemplate from "./locales/fr-CA/summaryTemplate.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false, // React handles XSS
    },
    ns: [
      "common",
      "auth",
      "adminPortal",
      "menuBar",
      "errors",
      "warnings",
      "configureStorage",
      "users",
      "roles",
      "connectors",
      "configureHeaders",
      "featureFlags",
      "dashboards",
      "search",
      "grid",
      "cxoneConnector",
      "five9Connector",
      "summary",
      "summaryTemplate",
    ],
    defaultNS: "common",
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        adminPortal: enAdminPortal,
        menuBar: enMenuBar,
        errors: enErrors,
        warnings: enWarnings,
        configureStorage: enConfigureStorage,
        users: enUsers,
        roles: enRoles,
        connectors: enConnectors,
        configureHeaders: enConfigureHeaders,
        featureFlags: enFeatureFlags,
        dashboards: enDashboards,
        search: enSearch,
        grid: enGrid,
        cxoneConnector: enCXoneConnector,
        five9Connector: enFive9Connector,
        amazonConnect: enAmazonConnectConnector,
        transcription: enTranscription,
        summary: enSummary,
        summaryTemplate: enSummaryTemplate,
      },
      "fr-CA": {
        common: frCACommon,
        auth: frCAAuth,
        adminPortal: frCAAdminPortal,
        menuBar: frCAMenuBar,
        errors: frCAErrors,
        warnings: frCAWarnings,
        configureStorage: frCAConfigureStorage,
        users: frCAUsers,
        roles: frCARoles,
        connectors: frCAConnectors,
        configureHeaders: frCAConfiugreHeaders,
        featureFlags: frCAFeatureFlags,
        dashboards: frCADashboards,
        search: frCASearch,
        grid: frCAGrid,
        cxoneConnector: frCACXoneConnector,
        five9Connector: frCAFive9Connector,
        amazonConnect: frCAAmazonConnectConnector,
        transcription: frCATranscription,
        summary: frCASummary,
        summaryTemplate: frCASummaryTemplate,
      },
    },
  });

export default i18n;
